// extracted by mini-css-extract-plugin
export default {"Balon_Container":"Balon_Balon_Container__6Pylt","border":"Balon_border__kqRMM","triangule":"Balon_triangule__LL78Q"};